import React from "react";
import NiceSVG from "src/icons/collections/integrations/NiceSVG.svg";

const NiceIcon = () => (<img src={NiceSVG} alt =''/>);

export default NiceIcon;
